<label class="label-xl-to-md fw-bold">
  {{ 'orderProcess.payment.reference.title' | translate }}
  <small class="fw-normal"
         [class.text-danger]="required()">
    @if (required()) {
      {{ 'common.required' | translate }}
    } @else {
      ({{ 'common.optional' | translate }})
    }
  </small>
</label>

<ui-input-with-tooltip
  [tooltipText]="'orderProcess.payment.reference.tooltipText' | translate">
  <input class="form-control position-relative"
         [name]="'reference'"
         [required]="required()"
         [maxlength]="128"
         [placeholder]="'orderProcess.payment.reference.placeholder' | translate"
         [ngModel]="reference()"
         (ngModelChange)="referenceChange.emit($event)" />
</ui-input-with-tooltip>
